import React from 'react';
import PropTypes from 'prop-types';
import Button from 'src/ui/library/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import styled from 'src/ui/library/styled';

const styles = (theme, props) => ({
  root: {},
  rootPaper: {
    padding: '0px',
  },
  title: {
    padding: '32px',
    margin: '0px',
    fontSize: '24px',
    color: theme.colors.eyConfidentGrey,
    borderBottom: '1px solid',
  },
  contentRoot: {
    padding: '0px 0px 0px 0px',
    borderBottom: '1px solid black',
  },
  contentText: {
    color: theme.colors.eyConfidentGrey,
    fontSize: '14px',
    marginLeft: '32px',
    marginRight: '32px',
  },
  actionsRoot: {
    margin: '24px 0px 0px 0px',
    justifyContent: 'flex-start',
    width: '100%',
    maxWidth: '400px',
  },
  buttonAction: {
    margin: '0px 16px 16px 32px',
    width: '50%',
  },
});

class SelectionPickBaseDialog extends React.Component {
  static propTypes = {
    /** Open/close dialog */
    open: PropTypes.bool.isRequired,
    /** Text for the Dialog title */
    title: PropTypes.string.isRequired,
    /** Text for the confirm button */
    confirmText: PropTypes.string.isRequired,
    /** Callback fired when confirm button click */
    onConfirm: PropTypes.func,
    /** Classes injected from MUI Styles */
    classes: PropTypes.object,
    /** Provided children */
    children: PropTypes.node,
  };

  static defaultProps = {
    maxWidth: 'md',
  };

  render() {
    const { maxWidth, confirmText, onConfirm, title, classes, children, open } = this.props;

    return (
      <Dialog maxWidth={maxWidth} classes={{ root: classes.root, paper: classes.rootPaper }} open={open}>
        <h2 className={classes.title} id="confirm-title">
          {title}
        </h2>
        <DialogContent classes={{ root: classes.contentRoot }}>
          <DialogContentText classes={{ root: classes.contentText }}>{children}</DialogContentText>
        </DialogContent>
        <DialogActions classes={{ root: classes.actionsRoot, action: classes.buttonAction }}>
          <Button onClick={onConfirm || null} noMaxWidth={true}>
            {confirmText}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export { SelectionPickBaseDialog };
export default styled(SelectionPickBaseDialog)(styles);
